(() => {
  'use strict';

  const root = document.getElementById('aw-brand-compare');
  const dataNode = document.getElementById('aw-brand-comparator-data');
  if (!root || !dataNode) return;

  const VERSION = 'AW-BRAND-COMPARE-P2-V8-NATIVE-BUDGET-20260913';
  const COMPAT_VERSION = 'AW-BRAND-COMPAT-SUMMARY-P2-V1';
  const BUDGET_VERSION = 'AW-BRAND-BUDGET-ADMIN-P2-V1-20260913';
  const MAX_RESULTS = 12;
  const MAX_COMPARE = 4;

  const BUDGET = Object.freeze({
    'asg': { status: 'ok', amount: 5.99, currency: 'EUR' },
    'aac-action-army-company': { status: 'ok', amount: 11.99, currency: 'EUR' },
    'ares-airsoft': { status: 'ok', amount: 39.99, currency: 'EUR' },
    'cyma-airsoft': { status: 'ok', amount: 39.99, currency: 'EUR' },
    'g-g-armament-guay-guay': { status: 'ok', amount: 21.99, currency: 'EUR' },
    'vfc-vega-force-company': { status: 'ok', amount: 53.99, currency: 'EUR' },
    'jing-gong-jg-works-jg-airsoft': { status: 'none' },
    'kj-works-kj-works-airsoft': { status: 'none' },
    'tokyo-marui-airsoft': { status: 'ok', amount: 39.99, currency: 'EUR' },
    'specna-arms': { status: 'ok', amount: 52.99, currency: 'EUR' },
    'we-airsoft': { status: 'ok', amount: 71.99, currency: 'EUR' },
    's-t-airsoft': { status: 'ok', amount: 10.99, currency: 'EUR' },
    'wolverine-airsoft': { status: 'ok', amount: 1649.99, currency: 'EUR' },
    'umarex-airsoft': { status: 'ok', amount: 57.99, currency: 'EUR' },
    'double-eagle-airsoft': { status: 'ok', amount: 704.99, currency: 'EUR' },
    'golden-eagle-airsoft': { status: 'ok', amount: 209.99, currency: 'EUR' },
    'agm-airsoft': { status: 'none' },
    'snow-wolf-airsoft': { status: 'ok', amount: 299.99, currency: 'EUR' },
    'd-boys-airsoft': { status: 'none' }
  });

  let payload;
  try {
    payload = JSON.parse(dataNode.textContent || '{}');
  } catch (error) {
    console.warn('[AW Brand Comparator V8] invalid data payload', error);
    return;
  }

  const brands = Array.isArray(payload.brands) ? payload.brands : [];
  const collator = new Intl.Collator('fr', { sensitivity: 'base', numeric: true });
  const euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  const form = root.querySelector('[data-aw-brand-compare-form]');
  const platformSelect = root.querySelector('[data-awbc-platform]');
  const technologySelect = root.querySelector('[data-awbc-technology]');
  const segmentSelect = root.querySelector('[data-awbc-segment]');
  const objectiveSelect = root.querySelector('[data-awbc-objective]');
  const gameSelect = root.querySelector('[data-awbc-game]');
  const budgetInput = root.querySelector('[data-awbc-budget]');
  const garageSelect = root.querySelector('[data-awbc-garage]');
  const garageNote = root.querySelector('[data-awbc-garage-note]');
  const statusNode = root.querySelector('[data-awbc-status]');
  const resultsNode = root.querySelector('[data-awbc-results]');
  const compareSection = root.querySelector('[data-awbc-compare]');
  const compareTable = root.querySelector('[data-awbc-table]');
  const resetButton = root.querySelector('[data-awbc-reset]');
  const clearCompareButton = root.querySelector('[data-awbc-clear-compare]');

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/₂/g, '2')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const same = (a, b) => normalize(a) === normalize(b);

  const normaliseTechs = (value) => {
    const raw = normalize(value);
    const out = [];
    const add = (tech) => { if (!out.includes(tech)) out.push(tech); };
    if (raw.includes('gbbr')) add('GBBR');
    if (raw.includes('gbb') && !raw.includes('gbbr')) add('GBB');
    if (raw.includes('aep')) add('AEP');
    if (raw.includes('aeg')) add('AEG');
    if (raw.includes('hpa')) add('HPA');
    if (raw.includes('nbb')) add('NBB');
    if (raw.includes('spring')) add('Spring');
    if (raw.includes('co2')) add('CO₂');
    if (raw.includes('gaz') || raw.includes('gas')) add('Gaz');
    return out;
  };

  const categories = (brand) => [brand.primary, ...(Array.isArray(brand.secondary) ? brand.secondary : [])]
    .filter(Boolean);

  const categoryHas = (brand, term) => categories(brand).some((value) => normalize(value).includes(normalize(term)));

  const segments = (brand) => {
    const out = [];
    if (categoryHas(brand, 'répliques')) out.push('replica');
    if (categoryHas(brand, 'upgrade') || categoryHas(brand, 'hpa')) out.push('upgrade');
    if (['tactique', 'électronique', 'optiques', 'protection', 'consommables', 'hors airsoft']
      .some((term) => categoryHas(brand, term))) out.push('equipment');
    if (!out.length) out.push('equipment');
    return out;
  };

  const brandTechnologies = (brand, selectedPlatform = '') => {
    const set = new Set();
    (Array.isArray(brand.platforms) ? brand.platforms : []).forEach((platform) => {
      if (selectedPlatform && !same(platform.name, selectedPlatform)) return;
      (Array.isArray(platform.technologies) ? platform.technologies : []).forEach((raw) => {
        normaliseTechs(raw).forEach((tech) => set.add(tech));
      });
    });
    return Array.from(set);
  };

  const hasPlatform = (brand, platform) => !platform || (Array.isArray(brand.platforms)
    && brand.platforms.some((candidate) => same(candidate.name, platform)));

  const directSummaryValid = (brand) => Boolean(
    brand
    && brand.directRelationsResolved
    && brand.compatibilitySummaryVersion === COMPAT_VERSION
    && Number(brand.directRelationsCount || 0) > 0
  );

  const exactDirectProof = (brand, platform) => Boolean(
    platform
    && directSummaryValid(brand)
    && Array.isArray(brand.directRelationPlatforms)
    && brand.directRelationPlatforms.some((candidate) => same(candidate, platform))
  );

  const objectiveMatch = (brand, objective) => {
    if (!objective) return true;
    if (objective === 'upgrade') return categoryHas(brand, 'upgrade') || categoryHas(brand, 'hpa');
    if (objective === 'hpa') {
      return categoryHas(brand, 'hpa') || brandTechnologies(brand).includes('HPA');
    }
    if (objective === 'optics') return categoryHas(brand, 'optiques');
    if (objective === 'tactical') return categoryHas(brand, 'tactique');
    return true;
  };

  const structuralMatch = (brand, state) => {
    if (state.platform && !hasPlatform(brand, state.platform)) return false;
    if (state.technology && !brandTechnologies(brand, state.platform).includes(state.technology)) return false;
    if (state.segment && !segments(brand).includes(state.segment)) return false;
    if (state.objective && !objectiveMatch(brand, state.objective)) return false;
    return true;
  };

  const budgetFor = (brand, maxBudget) => {
    if (!maxBudget) return { status: 'not_requested', rank: 0, verified: false };
    const entry = BUDGET[String(brand.handle || '')];
    if (!entry) return { status: 'unverified', rank: 3, verified: false };
    if (entry.status === 'none') {
      return { status: 'none', rank: 2, verified: true, sourceVersion: BUDGET_VERSION };
    }
    const amount = Number(entry.amount);
    if (!Number.isFinite(amount)) return { status: 'unverified', rank: 3, verified: false };
    return {
      status: amount <= maxBudget ? 'within' : 'over',
      rank: amount <= maxBudget ? 0 : 1,
      verified: true,
      amount,
      currency: entry.currency || 'EUR',
      sourceVersion: BUDGET_VERSION
    };
  };

  const budgetText = (evaluation, maxBudget) => {
    if (!maxBudget || evaluation.status === 'not_requested') return '';
    if (evaluation.status === 'within') {
      return `Catalogue AW vérifié : disponible trouvé dès ${euro.format(evaluation.amount)} ≤ budget ${euro.format(maxBudget)}`;
    }
    if (evaluation.status === 'over') {
      return `Catalogue AW vérifié : premier disponible trouvé à ${euro.format(evaluation.amount)} > budget ${euro.format(maxBudget)}`;
    }
    if (evaluation.status === 'none') {
      return 'Catalogue AW vérifié : aucun produit ACTIVE, public et disponible trouvé';
    }
    return 'Budget non vérifié pour cette marque';
  };

  const garageKeys = [
    'aw_garage_replicas_v1',
    'aw_upgrade_timeline_v1',
    'aw_build_replica_links_v1',
    'aw_airsoft_saved_configurations',
    'aw.garage.p2'
  ];

  const flattenGarageObjects = (value, out = [], depth = 0) => {
    if (depth > 6 || value == null) return out;
    if (Array.isArray(value)) {
      value.forEach((item) => flattenGarageObjects(item, out, depth + 1));
      return out;
    }
    if (typeof value === 'object') {
      out.push(value);
      Object.values(value).forEach((item) => {
        if (item && typeof item === 'object') flattenGarageObjects(item, out, depth + 1);
      });
    }
    return out;
  };

  const textFromObject = (obj) => {
    const values = [];
    Object.entries(obj || {}).forEach(([key, value]) => {
      if (value == null || typeof value === 'object') return;
      if (/(title|name|brand|vendor|handle|url|replica|product|modele|model)/i.test(key)) values.push(String(value));
    });
    return values.join(' · ');
  };

  const brandForText = (text) => {
    const haystack = normalize(text);
    if (!haystack) return '';
    const matches = brands
      .map((brand) => {
        const needles = [brand.title, ...(Array.isArray(brand.aliases) ? brand.aliases : [])]
          .filter(Boolean)
          .map(normalize)
          .filter((value) => value.length >= 3);
        const longest = needles.filter((needle) => haystack.includes(needle))
          .sort((a, b) => b.length - a.length)[0];
        return longest ? { handle: brand.handle, length: longest.length } : null;
      })
      .filter(Boolean)
      .sort((a, b) => b.length - a.length);
    return matches[0]?.handle || '';
  };

  const loadGarage = () => {
    const items = [];
    const seen = new Set();
    garageKeys.forEach((key) => {
      let parsed;
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return;
        parsed = JSON.parse(raw);
      } catch (_) {
        return;
      }
      flattenGarageObjects(parsed).forEach((obj) => {
        const text = textFromObject(obj);
        if (!text || text.length < 3) return;
        const label = String(
          obj.title || obj.name || obj.productTitle || obj.product_title ||
          obj.replicaName || obj.replica_name || obj.model || obj.modele || text
        ).trim();
        if (!label || label.length > 180) return;
        const brandHandle = brandForText(text);
        const fingerprint = `${normalize(label)}|${brandHandle}`;
        if (seen.has(fingerprint)) return;
        seen.add(fingerprint);
        items.push({
          id: `${key}:${items.length}`,
          label,
          brandHandle,
          rawText: text
        });
      });
    });
    return items.slice(0, 50);
  };

  const garageItems = loadGarage();
  const garageById = new Map(garageItems.map((item) => [item.id, item]));

  const garageContinuity = (brand, garageId) => {
    if (!garageId) return false;
    const item = garageById.get(garageId);
    return Boolean(item?.brandHandle && item.brandHandle === brand.handle);
  };

  const fillSelect = (select, values) => {
    if (!select) return;
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  };

  const allPlatforms = Array.from(new Set(brands.flatMap((brand) =>
    (Array.isArray(brand.platforms) ? brand.platforms : []).map((platform) => String(platform.name || '').trim()).filter(Boolean)
  ))).sort(collator.compare);

  const techOrder = ['AEG', 'AEP', 'CO₂', 'Gaz', 'GBB', 'GBBR', 'HPA', 'NBB', 'Spring'];
  const allTechs = new Set(brands.flatMap((brand) => brandTechnologies(brand)));
  const technologies = techOrder.filter((tech) => allTechs.has(tech));

  fillSelect(platformSelect, allPlatforms);
  fillSelect(technologySelect, technologies);

  if (garageSelect) {
    if (garageItems.length) {
      garageSelect.disabled = false;
      garageItems.forEach((item) => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.label;
        garageSelect.appendChild(option);
      });
      if (garageNote) {
        garageNote.textContent = 'Le Garage local fournit uniquement un signal de continuité de marque. Il ne crée jamais une preuve Compatibility.';
      }
    } else {
      garageSelect.disabled = true;
      if (garageNote) {
        garageNote.textContent = 'Aucune réplique trouvée dans le Garage local de cet appareil. Aucune donnée de compte n’est supposée.';
      }
    }
  }

  const readState = () => ({
    platform: platformSelect?.value || '',
    technology: technologySelect?.value || '',
    segment: segmentSelect?.value || '',
    objective: objectiveSelect?.value || '',
    game: gameSelect?.value || '',
    budget: Math.max(0, Number(budgetInput?.value || 0) || 0),
    garage: garageSelect?.value || ''
  });

  const setStateFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const setIfExists = (element, key) => {
      const value = params.get(key);
      if (element && value != null && Array.from(element.options || []).some((option) => option.value === value)) {
        element.value = value;
      }
    };
    setIfExists(platformSelect, 'awcmp_platform');
    setIfExists(technologySelect, 'awcmp_technology');
    setIfExists(segmentSelect, 'awcmp_segment');
    setIfExists(objectiveSelect, 'awcmp_objective');
    setIfExists(gameSelect, 'awcmp_game');
    setIfExists(garageSelect, 'awcmp_garage');
    if (budgetInput && params.get('awcmp_budget')) budgetInput.value = params.get('awcmp_budget');
  };

  const updateStateUrl = (state) => {
    try {
      const url = new URL(window.location.href);
      const pairs = [
        ['awcmp_platform', state.platform],
        ['awcmp_technology', state.technology],
        ['awcmp_segment', state.segment],
        ['awcmp_objective', state.objective],
        ['awcmp_game', state.game],
        ['awcmp_budget', state.budget ? String(state.budget) : ''],
        ['awcmp_garage', state.garage]
      ];
      pairs.forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      });
      history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (_) {}
  };

  const selectedCompareHandlesFromUrl = () => {
    try {
      return (new URLSearchParams(window.location.search).get('awcmp_compare') || '')
        .split(',')
        .map((value) => decodeURIComponent(value).trim())
        .filter(Boolean)
        .slice(0, MAX_COMPARE);
    } catch (_) {
      return [];
    }
  };

  let compareHandles = selectedCompareHandlesFromUrl();

  const updateCompareUrl = () => {
    try {
      const url = new URL(window.location.href);
      if (compareHandles.length) url.searchParams.set('awcmp_compare', compareHandles.join(','));
      else url.searchParams.delete('awcmp_compare');
      history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (_) {}
  };

  const compareLabel = (brand, state) => exactDirectProof(brand, state.platform)
    ? `Oui — documentée sous condition sur ${state.platform}`
    : (state.platform ? 'Non documentée directement sur cette plateforme' : 'Plateforme non sélectionnée');

  const relationText = (brand, state) => {
    const count = Number(brand.directRelationsCount || 0);
    if (state.platform && exactDirectProof(brand, state.platform)) {
      return `Compatibility AW directe documentée sous condition sur ${state.platform}`;
    }
    if (directSummaryValid(brand)) {
      return state.platform
        ? `${count} relation${count > 1 ? 's' : ''} Compatibility AW directe${count > 1 ? 's' : ''} documentée${count > 1 ? 's' : ''} sous condition ; aucune preuve directe ici sur ${state.platform}. Cela ne signifie pas incompatibilité.`
        : `${count} relation${count > 1 ? 's' : ''} Compatibility AW directe${count > 1 ? 's' : ''} documentée${count > 1 ? 's' : ''} sous condition.`;
    }
    return state.platform
      ? `Aucune preuve Compatibility AW directe documentée dans le résumé actuel sur ${state.platform}. Cela ne signifie pas incompatibilité.`
      : 'Aucune relation Compatibility AW directe documentée dans le résumé actuel.';
  };

  const rankResults = (items, state) => items.sort((a, b) => {
    if (state.platform) {
      if (a.directProof !== b.directProof) return b.directProof - a.directProof;
      if (state.budget && a.budget.rank !== b.budget.rank) return a.budget.rank - b.budget.rank;
      if (a.garage !== b.garage) return b.garage - a.garage;
      return collator.compare(a.brand.title, b.brand.title);
    }
    if (state.budget && a.budget.rank !== b.budget.rank) return a.budget.rank - b.budget.rank;
    const aEvidence = directSummaryValid(a.brand) ? 1 : 0;
    const bEvidence = directSummaryValid(b.brand) ? 1 : 0;
    if (aEvidence !== bEvidence) return bEvidence - aEvidence;
    if (a.garage !== b.garage) return b.garage - a.garage;
    return collator.compare(a.brand.title, b.brand.title);
  });

  const cardHtml = (item, state) => {
    const { brand, budget, directProof, garage } = item;
    const relationCount = Number(brand.directRelationsCount || 0);
    const checked = compareHandles.includes(brand.handle) ? ' checked' : '';
    const compatibilityUrl = state.platform
      ? `/pages/compatibilite-airsoft?aw_platform=${encodeURIComponent(state.platform)}`
      : '/pages/compatibilite-airsoft';
    const context = [];
    if (directProof) context.push(`Compatibility AW directe documentée sous condition sur ${state.platform}`);
    else if (state.platform) context.push(`Plateforme structurée : ${state.platform}`);
    if (state.technology) context.push(`Technologie : ${state.technology}`);
    if (state.objective) context.push(`Objectif : ${objectiveSelect?.selectedOptions?.[0]?.textContent || state.objective}`);
    if (state.game) context.push(`Type de jeu : ${gameSelect?.selectedOptions?.[0]?.textContent || state.game} (informatif, non classant)`);
    if (garage) context.push('Continuité de marque avec le Garage local — pas une preuve de compatibilité');

    return `
      <article class="aw-brand-compare__card" data-brand-handle="${escapeHtml(brand.handle)}" data-brand-url="${escapeHtml(brand.url)}">
        <div class="aw-brand-compare__card-head">
          <div>
            <h3>${escapeHtml(brand.title)}</h3>
            <p>${escapeHtml(brand.role || '')}${brand.primary ? ` · ${escapeHtml(brand.primary)}` : ''}</p>
          </div>
          ${directProof ? '<span class="aw-brand-compare__proof">PREUVE AW DIRECTE</span>' : ''}
        </div>
        <dl>
          <dt>Modèles exacts AW</dt><dd>${Number(brand.technicalModelsCount || 0)}</dd>
          <dt>Plateformes techniques</dt><dd>${Number(brand.technicalPlatformsCount || 0)}</dd>
          <dt>Relations Compatibility directes sous condition</dt><dd>${relationCount}</dd>
        </dl>
        ${state.budget ? `<p class="aw-brand-compare__budget" data-awbc-budget-status="${escapeHtml(budget.status)}">${escapeHtml(budgetText(budget, state.budget))}</p>` : ''}
        <p class="aw-brand-compare__proof-note">${escapeHtml(relationText(brand, state))}</p>
        ${context.length ? `<ul class="aw-brand-compare__context">${context.map((value) => `<li>${escapeHtml(value)}</li>`).join('')}</ul>` : ''}
        <div class="aw-brand-compare__links">
          <a href="${escapeHtml(brand.url)}">Voir la fiche marque</a>
          <a href="${escapeHtml(compatibilityUrl)}">Ouvrir Compatibility</a>
        </div>
        <label class="aw-brand-compare__pick">
          <input type="checkbox" data-awbc-compare-brand="${escapeHtml(brand.handle)}"${checked}>
          <span>Comparer</span>
        </label>
      </article>
    `;
  };

  const renderCompare = (state, allRanked) => {
    if (!compareSection || !compareTable) return;
    const selected = compareHandles
      .map((handle) => allRanked.find((item) => item.brand.handle === handle)
        || (() => {
          const brand = brands.find((candidate) => candidate.handle === handle);
          if (!brand) return null;
          return {
            brand,
            directProof: exactDirectProof(brand, state.platform) ? 1 : 0,
            budget: budgetFor(brand, state.budget),
            garage: garageContinuity(brand, state.garage) ? 1 : 0
          };
        })())
      .filter(Boolean)
      .slice(0, MAX_COMPARE);

    if (!selected.length) {
      compareSection.hidden = true;
      compareTable.innerHTML = '';
      return;
    }

    compareSection.hidden = false;
    const header = `<tr><th scope="col">Critère</th>${selected.map((item) => `<th scope="col">${escapeHtml(item.brand.title)}</th>`).join('')}</tr>`;
    const row = (label, values) => `<tr><th scope="row">${escapeHtml(label)}</th>${values.map((value) => `<td>${escapeHtml(value)}</td>`).join('')}</tr>`;
    const rows = [
      row('Famille principale', selected.map((item) => item.brand.primary || '—')),
      row('Budget', selected.map((item) => state.budget ? budgetText(item.budget, state.budget) : 'Non demandé')),
      row('Modèles exacts AW', selected.map((item) => String(Number(item.brand.technicalModelsCount || 0)))),
      row('Plateformes techniques', selected.map((item) => String(Number(item.brand.technicalPlatformsCount || 0)))),
      row('Relations Compatibility directes sous condition', selected.map((item) => String(Number(item.brand.directRelationsCount || 0)))),
      row(state.platform ? `Preuve directe sur ${state.platform}` : 'Preuve plateforme', selected.map((item) => compareLabel(item.brand, state))),
      row('Continuité Garage', selected.map((item) => item.garage ? 'Oui — continuité de marque seulement' : 'Non')),
      row('Technologies structurées', selected.map((item) => brandTechnologies(item.brand, state.platform).join(', ') || '—'))
    ].join('');
    compareTable.innerHTML = `<thead>${header}</thead><tbody>${rows}</tbody>`;
  };

  const render = () => {
    const state = readState();
    updateStateUrl(state);

    const matched = brands.filter((brand) => structuralMatch(brand, state));
    const ranked = rankResults(matched.map((brand) => ({
      brand,
      directProof: exactDirectProof(brand, state.platform) ? 1 : 0,
      budget: budgetFor(brand, state.budget),
      garage: garageContinuity(brand, state.garage) ? 1 : 0
    })), state);

    const exactCount = state.platform ? ranked.filter((item) => item.directProof).length : 0;
    const budgetVerified = state.budget ? ranked.filter((item) => item.budget.verified).length : 0;
    const budgetUnverified = state.budget ? ranked.length - budgetVerified : 0;
    const shown = ranked.slice(0, MAX_RESULTS);

    if (statusNode) {
      const parts = [`${ranked.length} marque${ranked.length > 1 ? 's' : ''} correspondent aux critères structurés.`];
      if (state.platform) {
        parts.push(`${exactCount} marque${exactCount > 1 ? 's' : ''} ${exactCount > 1 ? 'ont' : 'a'} une preuve Compatibility AW directe sous condition sur ${state.platform}.`);
      }
      if (state.budget) {
        parts.push(`Budget Admin vérifié pour ${budgetVerified} marque${budgetVerified > 1 ? 's' : ''} ; ${budgetUnverified} non vérifiée${budgetUnverified > 1 ? 's' : ''}.`);
      }
      if (state.game) {
        parts.push('Le type de jeu reste informatif et ne modifie pas le classement faute de taxonomie AW dédiée.');
      }
      parts.push(`Les ${Math.min(MAX_RESULTS, shown.length)} première${shown.length > 1 ? 's' : ''} sont affichées.`);
      statusNode.textContent = parts.join(' ');
    }

    if (resultsNode) {
      if (!shown.length) {
        resultsNode.hidden = false;
        resultsNode.innerHTML = '<div class="aw-brand-compare__empty"><strong>Aucune marque ne correspond à ces critères structurés.</strong><p>Élargissez la plateforme, la technologie, la famille ou l’objectif. Aucune compatibilité n’est inventée pour remplir les résultats.</p></div>';
      } else {
        resultsNode.hidden = false;
        resultsNode.innerHTML = shown.map((item) => cardHtml(item, state)).join('');
      }
    }

    renderCompare(state, ranked);
    root.dataset.awComparatorVersion = VERSION;
    root.dataset.awBudgetSnapshot = `${Object.keys(BUDGET).length}/19`;
    root.dataset.awCompatibilitySummary = `${brands.filter(directSummaryValid).length}/${brands.filter(directSummaryValid).reduce((sum, brand) => sum + Number(brand.directRelationsCount || 0), 0)}`;
  };

  const syncCompareChecks = () => {
    root.querySelectorAll('[data-awbc-compare-brand]').forEach((input) => {
      input.checked = compareHandles.includes(input.dataset.awbcCompareBrand || '');
    });
  };

  root.addEventListener('change', (event) => {
    const input = event.target?.closest?.('[data-awbc-compare-brand]');
    if (!input) return;
    const handle = input.dataset.awbcCompareBrand || '';
    if (!handle) return;

    if (input.checked) {
      if (!compareHandles.includes(handle) && compareHandles.length >= MAX_COMPARE) {
        input.checked = false;
        if (statusNode) statusNode.textContent = 'Vous pouvez comparer jusqu’à 4 marques à la fois.';
        return;
      }
      if (!compareHandles.includes(handle)) compareHandles.push(handle);
    } else {
      compareHandles = compareHandles.filter((value) => value !== handle);
    }
    updateCompareUrl();
    renderCompare(readState(), brands.map((brand) => ({
      brand,
      directProof: exactDirectProof(brand, readState().platform) ? 1 : 0,
      budget: budgetFor(brand, readState().budget),
      garage: garageContinuity(brand, readState().garage) ? 1 : 0
    })));
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    render();
  });

  resetButton?.addEventListener('click', () => {
    if (platformSelect) platformSelect.value = '';
    if (technologySelect) technologySelect.value = '';
    if (segmentSelect) segmentSelect.value = '';
    if (objectiveSelect) objectiveSelect.value = '';
    if (gameSelect) gameSelect.value = '';
    if (budgetInput) budgetInput.value = '';
    if (garageSelect) garageSelect.value = '';
    render();
  });

  clearCompareButton?.addEventListener('click', () => {
    compareHandles = [];
    updateCompareUrl();
    syncCompareChecks();
    renderCompare(readState(), []);
  });

  setStateFromUrl();

  const params = new URLSearchParams(window.location.search);
  const hasComparatorState = [
    'awcmp_platform', 'awcmp_technology', 'awcmp_segment', 'awcmp_objective',
    'awcmp_game', 'awcmp_budget', 'awcmp_garage', 'awcmp_compare'
  ].some((key) => params.has(key));

  if (hasComparatorState) render();
  else {
    root.dataset.awComparatorVersion = VERSION;
    root.dataset.awBudgetSnapshot = `${Object.keys(BUDGET).length}/19`;
    root.dataset.awCompatibilitySummary = `${brands.filter(directSummaryValid).length}/${brands.filter(directSummaryValid).reduce((sum, brand) => sum + Number(brand.directRelationsCount || 0), 0)}`;
  }
})();
